import { HttpHeaders, HttpParams } from "@angular/common/http";

export class HandShake {
    key : string;
    challenge : string;
}

export class OptionsType {
    headers? : HttpHeaders = new HttpHeaders;
    observe? : "body";
    params? : HttpParams | {[param : string] : string | string[] };
    reportProgress? : boolean;
    responseType? :"json";
    withCredentials : boolean;
}